export default "__VITE_ASSET__BjH6ZU5r__"